import {
  getListAssetsAssetsGetQueryKey,
  removeAssetAssetAssetIdDelete,
} from "@phc/common/gen/preferencesGen"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSnackbar } from "notistack"

export const useRemoveAsset = ({
  hideToast = false,
  skipQueryInvalidation = false,
}: { hideToast?: boolean; skipQueryInvalidation?: boolean } = {}) => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()
  const successMessage = "Your location has been removed."
  return useMutation({
    mutationFn: async (variables: { asset_id: string }) => {
      await removeAssetAssetAssetIdDelete(variables.asset_id)
    },
    onError: err => {
      if (!hideToast) {
        enqueueSnackbar("Unable to remove this location.", {
          variant: "error",
        })
      }
      console.error(err)
    },
    retry: 5,
    onSuccess: () => {
      if (!hideToast) {
        enqueueSnackbar(successMessage, {
          variant: "success",
        })
      }
    },
    onSettled: async () => {
      if (skipQueryInvalidation) return
      await queryClient.invalidateQueries({
        queryKey: getListAssetsAssetsGetQueryKey(),
      })
    },
  })
}
